// costa-rica-map.jsx — extraído de index.html el 2026-08-28 (Etapa 1, Bloque C).
//
// Hasta hoy este código vivía incrustado en index.html dentro de un
// <script type="text/babel"> que @babel/standalone compilaba en el navegador de
// cada visitante. El atributo data-source lo atribuía a «NUEVA WEB/costa-rica-map.jsx»,
// una carpeta que no existe en el repositorio ni en el disco: el bloque incrustado
// era la única fuente de verdad (hallazgo H5 del inventario).
//
// El contenido es copia EXACTA del bloque original. No se reformateó ni se
// renombró nada: se compila con las mismas opciones que aplicaba el CDN y la
// salida debe ser byte a byte la misma. Ver scripts/build-jsx.mjs.
//
// Se carga como script clásico, NO como módulo: las declaraciones de nivel
// superior son globales y las otras entradas del home las leen por nombre.

/* global React */
(() => {

// Stylized Costa Rica country shape (NW peninsula → SE Panama border).
// Path is in a 600 x 540 viewBox.
const CR_PATH = "M 92 138 C 86 132 84 124 90 116 C 100 104 122 100 138 110 C 152 118 156 130 168 134 C 184 138 196 130 210 120 C 224 110 240 100 258 102 C 280 105 296 120 312 132 C 328 144 344 152 360 158 C 380 165 402 168 422 178 C 442 188 458 204 470 222 C 480 238 484 256 482 274 C 480 296 470 316 456 332 C 442 348 422 356 402 360 C 380 364 358 358 340 348 C 322 338 308 322 296 308 C 282 292 268 280 252 274 C 234 268 214 270 198 280 C 180 290 166 304 154 318 C 142 334 132 348 116 354 C 100 360 84 354 76 340 C 70 328 72 312 80 300 C 92 282 110 270 124 254 C 138 240 148 222 150 204 C 152 188 146 172 134 162 C 122 152 106 148 92 138 Z";

const TERRAIN_BLOBS = [
  { cx: 180, cy: 200, rx: 50, ry: 32, fill: "#8aaa6e" },
  { cx: 260, cy: 230, rx: 70, ry: 40, fill: "#7a9e63" },
  { cx: 340, cy: 240, rx: 60, ry: 38, fill: "#9bb978" },
  { cx: 400, cy: 270, rx: 55, ry: 32, fill: "#6a8e58" },
  { cx: 220, cy: 280, rx: 45, ry: 28, fill: "#a3c281" },
];

const HERO_PINS = [
  { id: "guanacaste", x: 130, y: 180, label: "Guanacaste", color: "#f97316" },
  { id: "tamarindo",  x: 100, y: 222, label: "Tamarindo",  color: "#23aae0" },
  { id: "arenal",     x: 220, y: 200, label: "Arenal",     color: "#16a34a" },
  { id: "monteverde", x: 250, y: 248, label: "Monteverde", color: "#a855f7" },
  { id: "jaco",       x: 240, y: 290, label: "Jacó",       color: "#f2c94c" },
  { id: "manuel",     x: 300, y: 310, label: "Manuel Antonio", color: "#ef4444" },
  { id: "limon",      x: 410, y: 250, label: "Puerto Viejo", color: "#0f70b4" },
];

// Hero logo strip: each map badge links to its destination template (per
// language) once it exists; entries without URL render as static images.
const MAP_LOGO_URLS = {
  PJ: { en: '/en/jaco-beach/', es: '/es/playa-jaco/' },
  FA: { en: '/en/arenal-volcano-la-fortuna/', es: '/es/volcan-arenal-la-fortuna/' },
  TA: { en: '/en/tamarindo/', es: '/es/tamarindo/' },
  MA: { en: '/en/manuel-antonio-quepos/', es: '/es/manuel-antonio-quepos/' },
  CH: { en: '/en/playas-del-coco/', es: '/es/playas-del-coco/' },
  HE: { en: '/en/herradura/', es: '/es/herradura/' },
  DU: { en: '/en/costa-ballena/', es: '/es/costa-ballena/' },
};
const MAP_LOGOS = [
  { code: 'CH', src: '/imagenes/ventas/LOGO CH.webp', alt: "Playas del Coco & Hermosa's Map" },
  { code: 'TA', src: '/imagenes/ventas/LOGO TA.webp', alt: "Tamarindo's Map" },
  { code: 'PJ', src: '/imagenes/ventas/LOGO PJ.webp', alt: "Jacó's Map" },
  { code: 'MA', src: '/imagenes/ventas/LOGO MA.webp', alt: "Manuel Antonio & Quepos' Map" },
  { code: 'HE', src: '/imagenes/ventas/LOGO HE.webp', alt: "Herradura's Map" },
  { code: 'FA', src: '/imagenes/ventas/LOGO FA.webp', alt: "Arenal Volcano & La Fortuna's Map" },
  { code: 'DU', src: '/imagenes/ventas/LOGO DU.webp', alt: "Costa Ballena's Map" },
];

function CostaRicaMap({ activeId, onSelect, lang }) {
  return (
    <div className="hero__map">
      <div className="hero-art" role="img" aria-label="CRMaps interactive Costa Rica travel maps and digital guide">
        <img
          className="hero-art__layer hero-art__layer--landscape"
          src="/imagenes/index/background_maps.webp"
          alt=""
          aria-hidden="true"
          fetchPriority="high"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--map"
          src="/imagenes/index/costa_rica_map.webp"
          alt={lang === 'es'
            ? 'Mapa ilustrado de Costa Rica con sus playas, parques nacionales, volcanes, pueblos y costas'
            : 'Illustrated map of Costa Rica showing its beaches, national parks, volcanoes, towns and coastlines'}
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--devices"
          src="/imagenes/index/computadora_crmaps.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--covers"
          src="/imagenes/index/maps_covers.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--social"
          src="/imagenes/index/redes_crmasp.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--heart"
          src="/imagenes/index/corazon_redes.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--smile"
          src="/imagenes/index/sonrisa_redes.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--like"
          src="/imagenes/index/like_redes.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
        <img
          className="hero-art__layer hero-art__layer--like-secondary"
          src="/imagenes/index/like_redes.webp"
          alt=""
          aria-hidden="true"
          decoding="async"
        />
      </div>
      <div className="hero-art-logos">
        {MAP_LOGOS.map((item) => {
          const href = MAP_LOGO_URLS[item.code] && MAP_LOGO_URLS[item.code][lang === 'es' ? 'es' : 'en'];
          return href ? (
            <a key={item.code} className="hero-art-logos__item" href={href} aria-label={item.alt}>
              <img src={item.src} alt={item.alt} decoding="async" loading="lazy" />
            </a>
          ) : (
            <span key={item.code} className="hero-art-logos__item">
              <img src={item.src} alt="" aria-hidden="true" decoding="async" loading="lazy" />
            </span>
          );
        })}
      </div>
    </div>
  );
}

window.CostaRicaMap = CostaRicaMap;
window.HERO_PINS = HERO_PINS;
})();

  